import React, { ReactNode } from 'react';

type TranscludedChildren = ReactNode | ((renderProps: object) => ReactNode);

const TransclusionContext = React.createContext<{
  transclusions?: {
    children: TranscludedChildren;
  }[];
}>({});

export default TransclusionContext;
